import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import buildUpdateAuthorizedIpsRows from './buildUpdateAuthorizedIpsRows.helper';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const { Box, Button, Title, Table, TextField } = vp;

type UpdateAuthorizedIpsProps = {
  onSubmit: (params: vp.SaveAuthorizedIPsRequest) => void;
  onBack: () => void;
  defaultValues: vp.SaveAuthorizedIPsRequest;
};
type FC = FunctionComponent<UpdateAuthorizedIpsProps>;

const UpdateAuthorizedIpsReview: FC = (props: UpdateAuthorizedIpsProps) => {
  const { onSubmit, defaultValues, onBack } = props;
  const updateAuthorizedIpsRows = buildUpdateAuthorizedIpsRows();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ values, handleSubmit }) => {
        const updateAuthorizedIpsTable: vp.TableProps = {
          name: 'update-AuthorizedIps-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: updateAuthorizedIpsRows.map(({ label, id, preset }) => ({
            Field: label,
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={values[id]}
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box flx="col" mb="lg" gapSize="16px">
              <UtilButton iconLeft="chevron_left" size="large" onClick={onBack}>
                {tGlobal('Buttons.back')}
              </UtilButton>
              <Title title="Review and Save" />
            </Box>
            <Table {...updateAuthorizedIpsTable} />
            <Box width="100%" jc="fe" mt="md">
              <Button id="AuthorizedIps-submit" type="submit" label="Save" />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateAuthorizedIpsReview;
